<div class="container-fluid">
    <div class="row zsd-cust-common-container">
        <div class="col-lg-3 col-xl-2"></div>
        <div  class="col-lg-9 col-xl-10 col-md-9 col-xs-10 col-sm-10 col-10 pl-3 py-2">
            <ul class="nav nav-tabs outages_navbar-nav mr-auto" *ngIf="showOutageMenus">
                <li class="outages_nav-item">
                    <a class="outages_nav-link" [ngClass]="showOutagesTab? 'outages_nav-link active' : '' "  data-toggle="tab" 
                    (click)="gotToCurrentOutages()">
                        <span *ngIf="showOutageMenus" class="menu_link_text" aria-label="KnowledgeBase">
                            {{'OutagesList.outages' | translate | uppercase }} {{ outagesResultsCount }}
                        </span>
                    </a>
                </li>
                
                <li class="outages_nav-item ml-3">
                    <a class="outages_nav-link"  [ngClass]="!showOutagesTab? 'outages_nav-link active' : '' "   data-toggle="tab" 
                    (click)="gotoPlannedOutages()">
                        <span *ngIf="showOutageMenus"  class="menu_link_text" aria-label="KnowledgeBase">
                            {{'OutagesList.plannedOutages' | translate | uppercase }} {{ plannedOutagesResultsCount }}
                            <span></span>
                        </span>
                    </a>
                </li>
            </ul>
            <span class="zsd-cust-common-pageheading-font active" *ngIf="!canCusotmerViewPlannedOutages">{{ "OutagesList.outagesHeader" | translate }} {{ outagesResultsCount }} </span>
            <span class="zsd-cust-common-pageheading-font active" *ngIf="!canCustomerViewOutages">{{ "OutagesList.plannedOutagesHeader" | translate }} {{ plannedOutagesResultsCount }} </span>

        </div>
        <div class="col-md-3 col-xs-2 col-sm-2 col-2">
            <span style="float: right;">
                <em class="fa fa-filter d-block d-lg-none filter-action" (click)="openFilter()"></em>
            </span>
        </div>
    </div>
    <div class="row">
        <!-- style="position: sticky !important; top: 56px; z-index: initial;  max-width: 230px; max-height: 90vh; overflow: auto;" -->
        <div class="col-lg-3 col-xl-2">
            <zsd-outagesfilter></zsd-outagesfilter>
        </div>
        <div class="col-lg-9 col-xl-10 col-md-12 col-xs-12 col-sm-12 col-12">
                <router-outlet></router-outlet>
        </div>
    </div>
</div>
